import axios, {AxiosError} from "axios";
import { API_URL, ChangeLicenseResponse, ErrorResponse } from "../constant";
import { RegisterResponse } from "../constant";
  
export async function ChangeEmail(requestdata: any): Promise<RegisterResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/updateEmail`,
          requestdata,
          config,
        );
    
        if (response.status === 204)
        {
            return { success: true, msg: "Change Email Success"};
        }
        else if (response.status === 409)
        {
            return { success: false, msg: response.data.detail || "Validation Error" };
        }
        else if (response.status === 422)
        {
            return { success: false, msg: "Validation Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}

export async function ChangeLicense(requestdata: any): Promise<ChangeLicenseResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus:  (status: number) => status < 500
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/updateLicense`,
          requestdata,
          config,
        );
    
        if (response.status === 200)
        {
            return { success: true, broker: response.data, msg: ""};
        }
        else if (response.status === 400)
        {
            return { success: false, broker: null, msg: "Invalid LicenseNumber" };
        }
        else{
            return { success: false, broker: null, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 400)
            {
                return { success: false, broker: null, msg: "Invalid License Number" };
            }
            return { success: false, broker: null, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, broker: null, msg: "No response received from server" };
        } else {
            return { success: false, broker: null, msg: `Error:, ${error.message}` };
        }
    }
}